<template>
  <div class="svg-preview" style="overflow:auto">
    <el-tabs v-model="selectGroup" type="card" @tab-click="loadData()">
      <el-tab-pane v-for="(item,i) in groupList" :key="i" :label="item.GroupName" :name="item.GroupId" />
    </el-tabs>
    <div class="svg-contain tc">
      <div style="position: relative;margin: 0 auto;">
        <svg
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          style="background-color:#000000;max-width:100%"
          :viewBox="viewBox"
          :width="'100%'"
          :height="height">
          <defs />
          <g
            v-for="item in svgLists"
            :id="item.id"
            :key="item.type+item.id"
            :title="item.title"
            :transform="'translate('+(item.svgPositionX)+','+(item.svgPositionY)+')' +'rotate('+item.angle+')' +'scale('+item.size+')'"
            style="cursor: pointer;"
            @click="showPropCurve(item)"
            @mouseenter="hoverInfo(item)"
            @mouseleave="offInfo(item)">
            <component :is="item.type" :prop_data="item" />
          </g>
        </svg>
        <div style="position: absolute;top: 5px;color: #fff;left: 5px;">
          (画布大小:{{ wiringDiagram.Width }}px * {{ wiringDiagram.Height }}px) 最后一次修改:{{ wiringDiagram.CreateTime }}
        </div>
      </div>
    </div>
    <el-dialog
      dia-id="video-dia"
      :visible.sync="showVideo"
      :title="diaTitle_1"
      :class="{ dark: skinType }"
    >
      <monitoring-curve
        v-if="secDiaType == 1"
        :is_columnar_flag="is_columnar_flag"
        :equip-type="equipType"
        :prop-info="propInfo"
        :equipment-info="selectEquipment"
        class="flex-grow-1"
        style="min-height: 400px"
      />
      <div v-else class="overflow-y flex-wrap">
        <el-table
          size="small"
          :class="{ dark: skinType }"
          stripe
          :data="propertiesData"
          :row-class-name="
            (...nu) => {
              return skinType ? 'dark text-white' : '';
            }
          "
        >
          <el-table-column prop="Name" label="属性名称" />
          <el-table-column prop="Code" label="属性代码" />
          <el-table-column prop="Value" label="属性值" />
          <el-table-column prop="Time" label="记录时间" />
        </el-table>
      </div>
    </el-dialog>
    <div v-show="tooltipShow" id="tooltip" role="tooltip">
      {{ tooltipContent }}
      <div id="arrow" data-popper-arrow />
    </div>
  </div>
</template>
<script>
import SvgComponents from '@/components/svg-edit/components/SvgComponents.vue'
import { getSVGDataByIdStr, getRealTimeStatus, GetSVGGroupData } from '@/api/svg-edit/svgEdit'
import { createPopper } from '@popperjs/core'
import monitoringCurve from '@/components/general/monitoring-curve.vue'

export default {
  components: { SvgComponents, monitoringCurve },
  props: {
    svgId: {
      type: String,
      required: false,
      default: null
    }
  },
  data() {
    return {
      width: '100%',
      height: '100%',
      svgLists: [],
      svgInfoData: [],
      analogDataTimer: '', // 模拟数据定时器
      userInfo: '',
      editable: false,
      wiringDiagram: {},
      realTimeDataTimer: null,
      currentUsedDevices: [],
      currentUsedParentDevices: [],
      temObj: {},
      realTimeStatus: [],
      tooltipShow: false,
      tooltipContent: '',
      groupList: [],
      selectGroup: '',
      showVideo: false,
      secDiaType: 0,
      primaryType: 3,
      equipType: 0,
      diaTitle_1: '',
      selectEquipment: {},
      viewBox: '0 0 1920 1080'
    }
  },
  computed: {
    propertyName() {
      return function(val) {
        switch (val) {
          case ('Ia'): {
            return 'A相电流'
          }
          case ('Ib'): {
            return 'B相电流'
          }
          case ('Ic'): {
            return 'C相电流'
          }
          case ('Ua'): {
            return 'A相电压'
          }
          case ('Ub'): {
            return 'B相电压'
          }
          case ('Uc'): {
            return 'C相电压'
          }
          case ('ta'): {
            return 'A相温度'
          }
          case ('tb'): {
            return 'B相温度'
          }
          case ('tc'): {
            return 'C相温度'
          }
          case ('zygsz'): {
            return '正向有功示值'
          }
          default: {
            return ''
          }
        }
      }
    },
    skinType() {
      return this.$store.getters.skinType
    },
    // 属性tableData
    propertiesData() {
      return this.selectEquipment.JCX
    }
  },
  watch: {
    svgId: function(val) {
      if (val) {
        this.GetSVGGroupData()
      }
    }
  },
  created() {
  },
  beforeDestroy() {
    clearInterval(this.analogDataTimer)
  },
  methods: {
    GetSVGGroupData() {
      GetSVGGroupData({ IdStr: this.svgId }).then(e => {
        this.groupList = e
        if (e.length) {
          this.selectGroup = e[0].GroupId
          this.loadData()
        }
      }).catch(err => {
        this.$message.warning(err)
      })
    },
    async loadData() {
      getSVGDataByIdStr({ IdStr: this.svgId, GroupId: this.selectGroup }).then((res) => {
        if (res.length && res[0].Content) {
          this.wiringDiagram = res[0]
          this.viewBox = `0 0 ${res[0].Width} ${res[0].Height}`
          this.svgLists = JSON.parse(res[0].Content)
          this.width = res[0].Width + 'px'
          this.height = res[0].Height + 'px'
          // 获取实时状态
          this.getRealTimeStauts()
          if (this.analogDataTimer) {
            clearInterval(this.analogDataTimer)
          }
          this.analogDataTimer = setInterval(this.getRealTimeStauts, 3000)
        } else {
          this.svgLists = []
          this.width = 1920 + 'px'
          this.height = 1080 + 'px'
        }
      })
    },
    hoverInfo(item) {
      if (item.property) {
        this.tooltipShow = true
        const button = document.getElementById(item.id)
        const tooltip = document.querySelector('#tooltip')
        this.tooltipContent = this.propertyName(item.property) + ':' + item.title
        createPopper(button, tooltip, {
          placement: 'right',
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: [0, 8]
              }
            }
          ]
        })
      }
    },
    offInfo(item) {
      this.tooltipShow = false
    },
    getRealTimeStauts() {
      const arr = []
      this.svgLists.forEach((e) => {
        if (e.deviceId) {
          arr.push(e.deviceId)
        }
      })
      getRealTimeStatus({ EquipmentIdStr: Array.from(new Set(arr)).join('|') }).then((res) => {
        if (res) {
          this.realTimeStatus = res
          res.forEach((e) => {
            // 获取所有此设备的svg元素
            const svg = this.svgLists.filter(svg => {
              return e.TabIDstr === svg.deviceId
            })
            svg.forEach(t => {
              // 根据code找到对应属性，替换数值。
              if (t.property) {
                const property = e.Content.find(c => {
                  return t.property === c.Code
                })
                if (property) {
                  t.title = property.Value
                }
              }
            })
            // 获取开关元素
            const WireBreak = svg.find(s => {
              return s.type === 'WireBreak2OnSvg' || s.type === 'WireBreak2OffSvg'
            })
            // 获取开关元素
            const Compose = svg.find(s => {
              return s.type === 'ComposeOn' || s.type === 'ComposeOff'
            })
            if (Compose) {
              const Ia = e.Content.find(c => {
                return c.Code === 'Ia'
              })
              const Ib = e.Content.find(c => {
                return c.Code === 'Ib'
              })
              const Ic = e.Content.find(c => {
                return c.Code === 'Ic'
              })
              const zxyg = e.Content.find(c => {
                return c.Code === 'zygsz'
              })
              Compose.Ia = Ia.Value
              Compose.Ib = Ib.Value
              Compose.Ic = Ic.Value
              Compose.zxyg = zxyg.Value
              // 获取开关状态
              const state = e.Content.find(c => {
                return c.ID === 212
              })
              if (state) {
                if (Number(state.Value) === 1) {
                  // 找到开关 置为开
                  Compose.type = 'ComposeOn'
                } else {
                  // 找到开关 置为关
                  Compose.type = 'ComposeOff'
                }
              } else {
                if (Ia && Ib && Ic) {
                  if (Number(Ia.Value) + Number(Ib.Value) + Number(Ic.Value) > 0) {
                    // 找到开关 置为开
                    Compose.type = 'ComposeOn'
                  } else {
                    // 找到开关 置为关
                    Compose.type = 'ComposeOff'
                  }
                }
              }
            }
            if (WireBreak) {
              // 获取开关状态
              const state = e.Content.find(c => {
                return c.ID === 212
              })
              if (state) {
                if (Number(state.Value) === 1) {
                  // 找到开关 置为开
                  WireBreak.type = 'WireBreak2OnSvg'
                  WireBreak.svgColor = '#FF0000'
                } else {
                  // 找到开关 置为关
                  WireBreak.type = 'WireBreak2OffSvg'
                  WireBreak.svgColor = '#36FB05'
                }
              } else {
                // 判断abc三相电流，只要任意一项有，开关为开
                const Ia = e.Content.find(c => {
                  return c.Code === 'Ia'
                })
                const Ib = e.Content.find(c => {
                  return c.Code === 'Ib'
                })
                const Ic = e.Content.find(c => {
                  return c.Code === 'Ic'
                })
                if (Ia && Ib && Ic) {
                  if (Number(Ia.Value) + Number(Ib.Value) + Number(Ic.Value) > 0) {
                    // 找到开关 置为开
                    WireBreak.type = 'WireBreak2OnSvg'
                    WireBreak.svgColor = '#FF0000'
                  } else {
                    // 找到开关 置为关
                    WireBreak.type = 'WireBreak2OffSvg'
                    WireBreak.svgColor = '#36FB05'
                  }
                }
              }
            }
          })
        }
      }).catch(err => {
        this.$message.warning(err)
      })
      this.$forceUpdate()
    },
    showPropCurve(val) {
      console.log(val)
      if (val.property) {
        const item = this.realTimeStatus.find(e => {
          return e.TabIDstr === val.deviceId
        })
        item.JCX = item.Content
        const propInfo = item.Content.find(e => {
          return e.Code === val.property
        })
        this.equipType = propInfo.ID
        this.propInfo = propInfo
        this.secDiaType = 1
        this.diaTitle_1 = `${item.SBMName}--${propInfo.Name}`
        this.selectEquipment = item
        if (propInfo.Code === 'zygsz') {
          this.is_columnar_flag = true
        } else {
          this.is_columnar_flag = false
        }
        this.showVideo = true
      } else {
        const item = this.realTimeStatus.find(e => {
          return e.TabIDstr === val.deviceId
        })
        item.JCX = item.Content
        this.showAllProps(item)
      }
    },
    // 展示所有属性
    showAllProps(equipInfo, type = this.primaryType ? 3 : 0) {
      this.equipType = type
      this.secDiaType = 2
      this.diaTitle_1 = equipInfo.SBMName ? equipInfo.SBMName : equipInfo.Name
      this.selectEquipment = equipInfo
      this.showVideo = true
    },
    showCurve(equipInfo, type = this.primaryType ? 3 : 0) {
      this.equipType = type
      this.secDiaType = 1
      this.diaTitle_1 = equipInfo.SBMName ? equipInfo.SBMName : equipInfo.Name
      this.selectEquipment = equipInfo
      this.showVideo = true
    }
  }

}
</script>
<style lang="scss">
.svg-preview {
  .el-tabs {
    .el-tabs__header{
      margin: 0;
    }
    .el-tabs__item{
      font-size: 12px;
      line-height: 26px;
      height: auto
    }
  }
}
</style>
<style scoped lang="scss">
 #tooltip {
    background: rgb(65, 63, 63);
    color: white;
    font-weight: bold;
    padding: 4px 8px;
    font-size: 13px;
    border-radius: 4px;
  }
  #arrow,
  #arrow::before {
    position: absolute;
    width: 8px;
    height: 8px;
    background: inherit;
  }

  #arrow {
    visibility: hidden;
  }

  #arrow::before {
    visibility: visible;
    content: '';
    transform: rotate(45deg);
  }
  #tooltip[data-popper-placement^='top'] > #arrow {
    bottom: -4px;
  }

  #tooltip[data-popper-placement^='bottom'] > #arrow {
    top: -4px;
  }

  #tooltip[data-popper-placement^='left'] > #arrow {
    right: -4px;
  }

  #tooltip[data-popper-placement^='right'] > #arrow {
    left: -6px;
  }
</style>
